"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectValuesById = exports.selectStructureSizes = exports.selectStructureShowModelByType = exports.selectStructureShowModel = exports.selectStructurePositionsByType = exports.selectStructurePositions = exports.selectStructureByDepByTypeAndById = exports.selectStructureByDepAndByType = exports.selectHasData = exports.selectDevicesById = exports.selectDeviceValueByParams = exports.selectBuildings = exports.selectAllPwhCByHtgSys = exports.selectAllHtgHxByHtgSys = exports.selectActivePwhC = exports.selectActiveModelsByTypeAndById = exports.selectActiveModelsByType = exports.selectActiveHtgHx = exports.selectActiveBuildings = exports.getSelectedPoint = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _constants = require("../../utils/constants");
var _paulCorePackage = require("paul-core-package");
const selectBuildings = _ref => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref;
  return (components === null || components === void 0 ? void 0 : components.buildings) || [];
};
exports.selectBuildings = selectBuildings;
const selectActiveBuildings = _ref2 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref2;
  return (components === null || components === void 0 ? void 0 : components.activeBuildings) || null;
};
exports.selectActiveBuildings = selectActiveBuildings;
const selectActivePwhC = _ref3 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref3;
  return (components === null || components === void 0 ? void 0 : components.activePwhC) || null;
};
exports.selectActivePwhC = selectActivePwhC;
const selectActiveHtgHx = _ref4 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref4;
  return (components === null || components === void 0 ? void 0 : components.activeHtgHx) || null;
};
exports.selectActiveHtgHx = selectActiveHtgHx;
const selectActiveModelsByType = type => _ref5 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref5;
  return ((components === null || components === void 0 ? void 0 : components.activeModels.total) || {})[type] || {};
};
exports.selectActiveModelsByType = selectActiveModelsByType;
const selectActiveModelsByTypeAndById = _ref6 => {
  let {
    type,
    id
  } = _ref6;
  return _ref7 => {
    let {
      [_constants.packageKey]: {
        components
      } = {}
    } = _ref7;
    return (((components === null || components === void 0 ? void 0 : components.activeModels.total) || {})[type] || {})[id] || null;
  };
};
exports.selectActiveModelsByTypeAndById = selectActiveModelsByTypeAndById;
const selectStructureByDepAndByType = _ref8 => {
  let {
    type
  } = _ref8;
  return _ref9 => {
    let {
      [_constants.packageKey]: {
        components
      } = {}
    } = _ref9;
    return ((components === null || components === void 0 ? void 0 : components.activeModels.byDependencies) || {})[type] || [];
  };
};
exports.selectStructureByDepAndByType = selectStructureByDepAndByType;
const selectStructureByDepByTypeAndById = _ref10 => {
  let {
    type,
    id
  } = _ref10;
  return _ref11 => {
    let {
      [_constants.packageKey]: {
        components
      } = {}
    } = _ref11;
    return (((components === null || components === void 0 ? void 0 : components.activeModels.byDependencies) || {})[type] || {})[id] || null;
  };
};
exports.selectStructureByDepByTypeAndById = selectStructureByDepByTypeAndById;
const selectStructureSizes = _ref12 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref12;
  return (components === null || components === void 0 ? void 0 : components.activeModels.sizes) || {};
};
exports.selectStructureSizes = selectStructureSizes;
const selectStructurePositions = _ref13 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref13;
  return (components === null || components === void 0 ? void 0 : components.activeModels.positions) || _constants.defaultPositions;
};
exports.selectStructurePositions = selectStructurePositions;
const selectStructurePositionsByType = type => _ref14 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref14;
  return ((components === null || components === void 0 ? void 0 : components.activeModels.positions) || _constants.defaultPositions)[type];
};
exports.selectStructurePositionsByType = selectStructurePositionsByType;
const selectStructureShowModel = _ref15 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref15;
  return (components === null || components === void 0 ? void 0 : components.activeModels.showModel) || _constants.defaultShowModel;
};
exports.selectStructureShowModel = selectStructureShowModel;
const selectStructureShowModelByType = type => _ref16 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref16;
  return ((components === null || components === void 0 ? void 0 : components.activeModels.showModel) || _constants.defaultShowModel)[type];
};
exports.selectStructureShowModelByType = selectStructureShowModelByType;
const selectAllPwhCByHtgSys = _ref17 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref17;
  return (components === null || components === void 0 ? void 0 : components.allPwhCByHtgSys) || {};
};
exports.selectAllPwhCByHtgSys = selectAllPwhCByHtgSys;
const selectAllHtgHxByHtgSys = _ref18 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref18;
  return (components === null || components === void 0 ? void 0 : components.allHtgHxByHtgSys) || {};
};
exports.selectAllHtgHxByHtgSys = selectAllHtgHxByHtgSys;
const selectDevicesById = _ref19 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref19;
  return (components === null || components === void 0 ? void 0 : components.devices.byId) || {};
};
exports.selectDevicesById = selectDevicesById;
const selectValuesById = _ref20 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref20;
  return (components === null || components === void 0 ? void 0 : components.values.byId) || {};
};
exports.selectValuesById = selectValuesById;
const getSelectedPoint = _ref21 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref21;
  return (components === null || components === void 0 ? void 0 : components.selectedPoint) || null;
};
exports.getSelectedPoint = getSelectedPoint;
const selectHasData = _ref22 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref22;
  return (components === null || components === void 0 ? void 0 : components.hasData) || false;
};

/** @todo move to core selectDeviceValueByParams */
exports.selectHasData = selectHasData;
const selectDeviceValueByParams = (thingPDIDDevice, displayNameId) => _ref23 => {
  var _ref24;
  let {
    [_paulCorePackage.constants.packageKey]: {
      devices
    } = {}
  } = _ref23;
  return (_ref24 = (devices === null || devices === void 0 ? void 0 : devices.values.byId[thingPDIDDevice]) || {}) === null || _ref24 === void 0 ? void 0 : _ref24[displayNameId];
};
exports.selectDeviceValueByParams = selectDeviceValueByParams;